export const type = 'clickNotificaciones';

const clickNotificaciones = (text) => ({
    type,
    payload: new Date(),
    accion:text
});

export default clickNotificaciones;